const en = {
    MinimumLength: 'Minimum {num} characters',
    RequireNumbers: 'A number',
    RequireSymbols: 'A symbol',
    RequireLowercase: 'A lowercase letter',
    RequireUppercase: 'An uppercase letter',
};

export default en;
